import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

Bugsnag.start({
    apiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
    plugins: [new BugsnagPluginVue()],
    enabledReleaseStages: ['production', 'staging'],
    releaseStage: import.meta.env.MODE,
    appVersion: import.meta.env.VITE_APP_VERSION,
    autoTrackSessions: false,
});

export default Bugsnag;
